import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ContentSizes = styled('div')`
  width: 100%;
  margin-top: ${theme.spacing.lg};

  h3 {
    font-size: ${theme.typography.sizes.sm};
    color: ${theme.colors.neutral.high};
    font-weight: ${theme.typography.weight.xl};
  }
`

export const SizesStyled = styled('div')`
  .column {
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.spacing.xm};
    flex-grow: 0;
    margin-right: ${theme.spacing.xm};
    background: red;
  }
`

export const LabelStyled = styled('div')`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.xs};
`

export const SizeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 78px;
  width: fit-content;
  gap: ${theme.spacing.xs};
  padding: ${theme.spacing.sm};
  background-color: ${theme.colors.neutral[100]};
  border: 1px solid ${theme.colors.neutral.clear};
  border-radius: ${theme.shapes.borderRadius.sm};

  span {
    color: ${theme.colors.neutral.mediumhover};
    font-weight: ${theme.typography.weight.xsm};
  }
`
